var _defs, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{stroke:#fff;stroke-width:15px;}.d,.e{fill:none;stroke-linecap:round;stroke-miterlimit:10;}.f{fill:#fff;}.g{fill:#801950;}.e{stroke:#801950;stroke-width:40px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "g",
    cx: 256,
    cy: 272.07,
    r: 142.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M256,287.19c-8.35,0-15.13-6.77-15.13-15.13l6.58-83.89c0-8.35,.3-11.52,8.65-11.52s9.26,3.17,9.26,11.52l5.77,83.89c0,8.35-6.77,15.13-15.13,15.13Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 369.76,
    y1: 274.85,
    x2: 339.76,
    y2: 274.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 174.74,
    y1: 275.96,
    x2: 144.74,
    y2: 275.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 256.42,
    y1: 355.96,
    x2: 256.42,
    y2: 385.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M112.09,66.45c28.45,15.52,80.64,38.53,148.13,37.54,62.97-.92,111.82-22.34,139.68-37.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M381.62,442.77H130.38c-7.29,0-12.22-7.43-9.39-14.14l17.41-41.37c2.76-6.56,11.25-8.37,16.4-3.45,16.75,16.03,52.44,42.84,103.58,42.08,48.94-.74,82.87-26.3,99.16-41.94,5.17-4.96,13.71-3.14,16.45,3.48,5.69,13.75,11.38,27.51,17.07,41.26,2.78,6.71-2.16,14.09-9.42,14.09Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiet);
export default __webpack_public_path__ + "static/media/diet.6084526eddacb509ded418e153edac83.svg";
export { ForwardRef as ReactComponent };